<template>
  <div class="d-flex flex-row align-items-center justify-content-start wd-100p-force">
    <div class="form-group wd-250-force">
      <div class="input-group filter-input-group" :style="{'pointer-events': createInProgress ? 'none' : 'auto'}">
        <input type="text" v-mask="'# (###) ###-##-##'"  class="form-control" placeholder="Поиск номера" v-model="number" />
        <div class="input-group-append">
        <span class="input-group-text" v-on:click="number = ''; $emit('search-close')">
          <vue-feather type="x" :size="14" :style="{'opacity': searchEnabled ? '1' : '0', 'pointer-events': searchEnabled ? 'auto' : 'none'}" stroke="var(--cui-dark)"></vue-feather>
        </span>
        </div>
      </div>
    </div>
    <icon-button label="Найти"
                 :disabled="!searchAllowed || disabled ||createInProgress" :icon="disabled ? 'loader' : 'search'" :size="14" :padding="'5px 10px'"
                 :class="{'btn-outline-info' : !searchEnabled, 'btn-info': searchEnabled}"
                 v-on:click="$emit('search', numberFormatted)" class="btn btn-sm mg-rem-l-1 tx-12"></icon-button>
    <icon-button label="Добавить"
                  :icon="'plus'"
                 v-on:click="openAddForm"
                 :size="14" :padding="'5px 10px'" class="tx-12 btn-outline-success btn btn-sm mg-rem-l-1">
    </icon-button>
    <drop-down-button class="mg-rem-l-1" label="Операции" :size="14" :padding="'5px 10px'" :items="links" :disabled="disabled || createInProgress"></drop-down-button>
    <icon-button :size="14" :padding="'5px 10px'"
                 :label="'Скачать'"
                 :class-name="'tx-12 btn btn-sm btn-outline-info'"
                 icon="download"
                 style="margin-left: auto;"
                 v-on:click="$emit('download')"
    >
    </icon-button>
  </div>
</template>

<script>
import IconButton from "@/elements/IconLink";
import {TheMask,mask} from 'vue-the-mask'
import VueFeather from "vue-feather";
import DropDownButton from "@/elements/DropDownButton";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {h} from "vue";
import DialogUploadBlacklistExcel from "@/elements/DialogUploadBlacklistExcel";
import BlackListClass from '@/entities/Blacklist/BlackListClass';
import DialogAddNumbers from "@/elements/DialogAddNumbers";

export default {
  components: {IconButton, TheMask, VueFeather, DropDownButton},
  emits: ['search', 'search-close', 'create', 'remove-founded', 'download'],
  directives: { mask },
  props: {
    someSelected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    searchEnabled: false,
    createInProgress: false,
  },
  data() {
    return {
      number: ''
    }
  },
  methods: {
    openAddForm() {
      const { reveal } = createConfirmDialog(h(DialogAddNumbers, {
        NumbersClass: (new BlackListClass(this)),
        entityId: null,
        callback: () => {
          this.emitter.emit('blacklist-changed');
        }
      }));
      reveal();
    }
  },
  computed: {
    links: {
      get() {
        const result = [
          {
            label: 'Загрузить excel',
            click: () => {
              const { reveal } = createConfirmDialog(h(DialogUploadBlacklistExcel));
              reveal();
            }
          },
        ];

        if (this.searchEnabled) {
          result.push({
            label: 'Удалить найденные',
            click: () => { this.$emit('remove-founded'); }
          });
        }

        result.push({
              label: 'Удалить все',
              click: () => { this.$emit('remove-all'); }
        });

        return result;
      }
    },
    addAllowed: {
      get() {
        return this.numberFormatted.length === 11;
      }
    },
    searchAllowed: {
      get() {
        return this.numberFormatted.length >= 2;

      }
    },
    numberFormatted: {
      get() { return this.number ? this.number.replace(/\D/g,'') : ''; }
    }
  }
}
</script>